import { LayerDefinition } from './types';

export const auroraDefinition: LayerDefinition = {
  id: 'aurora',
  name: 'Aurora Borealis Forecast',
  category: 'space_astronomy',
  categoryLabel: 'Space Weather & Astronomical',
  icon: '🌌',
  description: 'Auroral oval Extent & Kp Index Northern Lights visibility forecast.',
  sourceModels: ['NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast'],
  outputModels: ['aurora_YYYY-MM-DD.pmtiles', 'aurora_viewline_YYYY-MM-DD.json', 'noaa_kp_forecast.json']
};

export default auroraDefinition;
